import React from 'react';
import './About.css';

function AboutPL() {
  return (
    <div className="about-container">
      <div className="main-content">
        <div className="photo-section">
          <img src={require("../assets/joanna-photo.png")} alt="Joanna w beżowym kapeluszu" />
        </div>

        <div className="text-section">
          <h2><span className="blue-text">Cześć,</span><br />Jestem Joanna</h2>
          
          <p>
            Jestem analityczką, <span className="blue-text">problem-solver</span> i osobą 
            z pasją do tworzenia user-centered designs. Uwielbiam łączyć technical constraints, cele biznesowe i zachowania ludzi, 
            wnosząc empatię do każdego projektu, by tworzyć intuicyjne doświadczenia cyfrowe, które wzbogacają życie użytkowników.
          </p>

          <p>
            Z <strong>doświadczeniem</strong> w <span className="blue-text">design</span>, <span className="blue-text">art</span> i dużym 
            zainteresowaniem <span className="blue-text">psychology</span>, fascynuje mnie, jak ludzie myślą, wchodzą w interakcje i podejmują decyzje. 
            Moja droga napędzana jest chęcią wprowadzania realnych zmian i poprawy życia. UX design pozwala mi <strong>łączyć moje umiejętności, ciekawość ludzkich zachowań</strong> i unikalną perspektywę, by mieć pozytywny wpływ.
          </p>

          <p>
            Poza pracą jestem podróżniczką, która <span className="blue-text">kocha naturę</span>, 
            hiking, yogę i poznawanie ludzi.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPL; 